<template>
  <v-card flat class="mt-2 mb-3">
    <v-tabs v-model="activityTab">
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab>Activity</v-tab>
      <v-tab>Email</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activityTab">
      <v-tab-item class="px-3">
        <v-card class="enquiry-list" light flat>
          <activity-list :activities="activities"></activity-list>
        </v-card>
      </v-tab-item>
      <v-tab-item class="px-3">
        <v-card class="enquiry-list" light flat>
          <email-list :emails="emails"></email-list>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ActivityList from './ActivityList';
import EmailList from '../Email/EmailList';

export default {
  components: {
    ActivityList,
    EmailList
  },
  name: 'enquiry-list',
  data: () => ({
    activityTab: 0
  }),
  computed: {
    ...mapGetters(['CustomerActivity']),
    activities: function() {
      return _.filter(this.CustomerActivity, { log_name: 'default' });
    },
    emails: function() {
      return _.filter(this.CustomerActivity, { log_name: 'mail' });
    }
  }
};
</script>

<style lang="scss" scoped>
.enquiry-list {
  height: calc(100vh - 265px);
  max-height: calc(100vh - 265px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  &.funder-view {
    height: calc(100vh - 210px);
    max-height: calc(100vh - 210px);
  }
}
</style>
